import _ from 'lodash';
import numeral from 'numeral';
import { CannabinoidAbbrev } from 'shared/constants/cannabinoids';
import { NUMERALS_DOLLAR_FORMAT } from 'shared/constants';
function extractValidationErrors(graphQLErrors) {
    var errors = _.filter(graphQLErrors, function(e) {
        return e.extensions.code === 'BAD_USER_INPUT' || e.extensions.code === 'UNPROCESSABLE_ENTITY';
    });
    return _.flatMap(errors, function(error) {
        return _.map(error.extensions.errors, 'detail');
    });
}
var formatPrice = function(price) {
    return numeral(parseFloat(price).toFixed(2)).format(NUMERALS_DOLLAR_FORMAT);
};
var formatFromCents = function(priceInCents) {
    return formatPrice(priceInCents / 100);
};
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function getBufferFromBase64Image() {
    var image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return Buffer.from(image.replace(/^data:image\/\w+;base64,/, ''), 'base64');
}
function isBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
}
// Check if an elem is visible on screen, and whether its above or below a certain offset
function isScrolledIntoView(elem) {
    var threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'visible';
    var rect = elem.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    var above = rect.bottom - threshold < 0;
    var below = rect.top - viewHeight + threshold >= 0;
    return mode === 'above' ? above : mode === 'below' ? below : !above && !below;
}
export function getHtmlPlainText(html, Parser) {
    if (!Parser) {
        console.log('DOMParser not available in this context. Is this a browser?');
        return '';
    }
    try {
        var parserInst = new Parser();
        return parserInst.parseFromString(html, 'text/html').documentElement.textContent;
    } catch (e) {
        console.log('Error found with dom parser.', e);
        return '';
    }
}
// normalizes noid abbrev, like THC-D9 -> D9-THC
var mapToStandardAbbreviation = function(abbrev) {
    return CannabinoidAbbrev[abbrev];
};
// Extracts noid abbrev from full text
// ex. '(CBDA) Cannablahblah' to 'CBDA' or '"TAC" - Total Noids' to 'TAC'
export var parseNoidAbbreviation = function(noidName) {
    var _exec;
    var _mapToStandardAbbreviation;
    return (_mapToStandardAbbreviation = mapToStandardAbbreviation((_exec = /[\w-]+/.exec(noidName)) === null || _exec === void 0 ? void 0 : _exec[0])) !== null && _mapToStandardAbbreviation !== void 0 ? _mapToStandardAbbreviation : noidName;
};
// Extracts noid long name from full text
// ex. '(CBDA) Cannablahblah' to 'Cannablahblah' or '"TAC" - Total Noids' to 'Total Noids'
export var parseNoidLongName = function(noidName) {
    var _exec;
    var _exec_;
    return (_exec_ = (_exec = /(?:\(|\W\s)+(.+\b)(?:\)|$)/.exec(noidName)) === null || _exec === void 0 ? void 0 : _exec[1]) !== null && _exec_ !== void 0 ? _exec_ : noidName;
};
export default {
    extractValidationErrors: extractValidationErrors,
    formatFromCents: formatFromCents,
    formatPrice: formatPrice,
    getBufferFromBase64Image: getBufferFromBase64Image,
    getDisplayName: getDisplayName,
    isBrowser: isBrowser,
    isScrolledIntoView: isScrolledIntoView
};
